import { createStore, applyMiddleware,compose } from 'redux'
import createSagaMiddleware from 'redux-saga'

import rootReducer from '../reducer/index'
import rootSaga from '../sagas/index'

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware()
// Mount it on the Store
const store = createStore(
    rootReducer,composeEnhancer
    (applyMiddleware(sagaMiddleware))
    
)

// Then run the saga
sagaMiddleware.run(rootSaga)

// Render the application

export default store